import React from 'react'

interface FilterProps {
  className?: string
}

const Filter: React.FC<FilterProps> = ({ className }: FilterProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Filter-1">
      <path
        id="Vector 45"
        d="M2 3.99982H10"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 55"
        d="M18 10L9 10"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 53"
        d="M2 16.0002H10"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 48"
        d="M13 3.99982L18 3.99982"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 56"
        d="M6 10L2 10"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector 54"
        d="M13 16.0002L18 16.0002"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        id="Rectangle 384"
        x="10"
        y="2"
        width="3"
        height="3"
        rx="1"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        id="Rectangle 389"
        width="3"
        height="3"
        rx="1"
        transform="matrix(-1 0 0 1 9 8)"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        id="Rectangle 388"
        x="10"
        y="14"
        width="3"
        height="3"
        rx="1"
        stroke="#6B6669"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

export default Filter
